export default __webpack_public_path__ + "static/media/Group 6506@3x.bf93a6a2.png";